import { useTranslation } from '@utils/i18n/i18n';

import './introduction.css';

function Introduction() {
  const { t } = useTranslation();

  return (
    <section className="introduction">
      <div className="introduction__content">
        <div>
          <p>
            {t('ENHANCE is an EU-funded project dedicated to protecting and restoring vulnerable coastal ecosystems through innovative, sustainable solutions. By integrating the One Health approach with cutting-edge AI technologies, satellite Copernicus’ observations and Citizen Science data services, we aim to empower stakeholders with dynamic tools and insights, supporting policymakers and businesses in crafting resilient strategies for coastal management.')}
          </p>
          <br></br>
           <p>
              {t('One of the project results is the ENHANCE toolkit for monitoring marine coastal ecosystems under the One Health Framework. This interface integrates the results produced in alignment with the three components of this framework in one overview:')}
            </p>
            <ul>
              <li>{t('Human health: assess the impact of water quality on human health by looking at different potential contaminations and bathing water safety')}</li>
              <li>{t('Animal health: analyze aquaculture sustainability and the impact of water quality on the health of animals in the area')}</li>
              <li>{t('Environmental health: evaluate biodiversity loss, pollution and the impact of pressures on the coastal environment')}</li>
            </ul>
            <p>
              {t('Through risk maps, policy makers are supported to analyze present and emerging coastal risks and make informed decisions about the future.')}
            </p>
        </div>
        <iframe
          src="https://www.youtube.com/embed/CRljcaEvHLg"
          title="YouTube video player"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="introduction__video"
        >
        </iframe>
      </div>
    </section>
  );
}

export default Introduction;
